import type { Template } from "@/types";

export const PO_05_H5_V0: Template[] = [
    {
        id: "po-05-h5v0-01",
        name: "PO 01 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_01.png",
        size: [1298, 827],
        style: {},
        slots: [          
            { id: "1", x: 45, y: 236, width: 270, height: 174, rotation: 0, imageRotation: 0 },
            { id: "2", x: 45, y: 418, width: 270, height: 173, rotation: 0, imageRotation: 0 },
            { id: "3", x: 323, y: 236, width: 270, height: 174, rotation: 0, imageRotation: 0 },
            { id: "4", x: 323, y: 418, width: 270, height: 173, rotation: 0, imageRotation: 0 },
            { id: "5", x: 700, y: 236, width: 548, height: 356, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h5v0-02",
        name: "PO 02 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_02.png",
        size: [1298, 827],
        style: {},
        slots: [       
            { id: "1", x: 0, y: 205, width: 319, height: 205, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 418, width: 319, height: 204, rotation: 0, imageRotation: 0 },
            { id: "3", x: 327, y: 205, width: 318, height: 205, rotation: 0, imageRotation: 0 },
            { id: "4", x: 327, y: 418, width: 318, height: 204, rotation: 0, imageRotation: 0 },
            { id: "5", x: 653, y: 205, width: 645, height: 417, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-05-h5v0-03",
        name: "PO 03 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_03.png",
        size: [1298, 827],
        style: {},
        slots: [          
            { id: "1", x: 0, y: 205, width: 319, height: 205, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 418, width: 319, height: 204, rotation: 0, imageRotation: 0 },
            { id: "3", x: 327, y: 205, width: 644, height: 417, rotation: 0, imageRotation: 0 },
            { id: "4", x: 979, y: 205, width: 319, height: 205, rotation: 0, imageRotation: 0 },
            { id: "5", x: 979, y: 418, width: 319, height: 204, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h5v0-04",
        name: "PO 04 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_04.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 51, y: 176, width: 548, height: 355, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 51, y: 539, width: 178, height: 113, rotation: 0, imageRotation: 0 },
            { id: "3", x: 237, y: 539, width: 177, height: 113, rotation: 0, imageRotation: 0 },
            { id: "4", x: 422, y: 539, width: 177, height: 113, rotation: 0, imageRotation: 0 },
            { id: "5", x: 700, y: 236, width: 548, height: 356, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h5v0-05",
        name: "PO 05 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_05.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 204, width: 649, height: 419, rotation: 0, imageRotation: 0 },
            { id: "2", x: 770, y: 617, width: 199, height: 126, rotation: 0, imageRotation: 0 },
            { id: "3", x: 977, y: 617, width: 199, height: 126, rotation: 0, imageRotation: 0 },
            { id: "4", x: 770, y: 84, width: 406, height: 259, rotation: 0, imageRotation: 0 },
            { id: "5", x: 770, y: 351, width: 406, height: 258, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h5v0-06",
        name: "PO 06 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_06.png",
        size: [1298, 827],
        style: {},
        slots: [           
            { id: "1", x: 55, y: 326, width: 270, height: 175, rotation: 0, imageRotation: 0 },
            { id: "2", x: 333, y: 326, width: 270, height: 175, rotation: 0, imageRotation: 0 },
            { id: "3", x: 197, y: 146, width: 271, height: 173, rotation: 0, imageRotation: 0 },
            { id: "4", x: 197, y: 508, width: 271, height: 173, rotation: 0, imageRotation: 0 },
            { id: "5", x: 700, y: 236, width: 548, height: 356, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h5v0-07",
        name: "PO 07 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_07.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 150, y: 81, width: 349, height: 216, rotation: 0, imageRotation: 0 },
            { id: "2", x: 150, y: 305, width: 349, height: 216, rotation: 0, imageRotation: 0 },
            { id: "3", x: 150, y: 529, width: 349, height: 216, rotation: 0, imageRotation: 0 },
            { id: "4", x: 721, y: 81, width: 506, height: 328, rotation: 0, imageRotation: 0 },
            { id: "5", x: 721, y: 417, width: 506, height: 328, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h5v0-08",
        name: "PO 08 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_08.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 40, y: 231, width: 567, height: 365, rotation: 0, imageRotation: 0 },
            { id: "2", x: 770, y: 83, width: 406, height: 259, rotation: 0, imageRotation: 0 },           
            { id: "3", x: 770, y: 350, width: 199, height: 126, rotation: 0, imageRotation: 0 },
            { id: "4", x: 977, y: 350, width: 199, height: 126, rotation: 0, imageRotation: 0 },
            { id: "5", x: 770, y: 484, width: 406, height: 259, rotation: 0, imageRotation: 0 }
           
        ],
    },

    {
        id: "po-05-h5v0-09",
        name: "PO 09 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_09.png",
        size: [1298, 827],
        style: {},
        slots: [          
            { id: "1", x: 73, y: 221, width: 283, height: 190, rotation: 0, imageRotation: 0 },
            { id: "2", x: 73, y: 419, width: 283, height: 189, rotation: 0, imageRotation: 0 },
            { id: "3", x: 364, y: 221, width: 571, height: 387, rotation: 0, imageRotation: 0 },
            { id: "4", x: 943, y: 221, width: 282, height: 190, rotation: 0, imageRotation: 0 },
            { id: "5", x: 943, y: 419, width: 282, height: 189, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h5v0-10",
        name: "PO 10 - H5V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h5_v0_10.png",
        size: [1298, 827],
        style: {},
        slots: [          
            { id: "1", x: 73, y: 121, width: 224, height: 141, rotation: 0, imageRotation: 0 },
            { id: "2", x: 73, y: 270, width: 224, height: 140, rotation: 0, imageRotation: 0 },
            { id: "3", x: 73, y: 418, width: 224, height: 140, rotation: 0, imageRotation: 0 },
            { id: "4", x: 73, y: 566, width: 224, height: 140, rotation: 0, imageRotation: 0 },
            { id: "5", x: 305, y: 121, width: 920, height: 585, rotation: 0, imageRotation: 0 }
        ],
    }
];